import type { NavigationFailure, RouteLocationNormalized } from 'vue-router';
import { useAnalytics } from '@/composables/analytics/analytics-service';
import { setCurrentRouteName } from '@/composables/analytics/current-route';

/**
 * Record the route that settled, then report the page view.
 *
 * The ApalumaBackendProvider handles the POST /analytics/user-activity mapping
 * internally.
 *
 * An `afterEach` rather than a guard, and in this order, for three reasons. A
 * navigation still in flight has put nothing on screen, so recording it early
 * would make every event report the screen the user was heading to rather than
 * the one they acted on. `page:view` has to be emitted after the route is
 * recorded, or it alone would report the previous screen as its own. And
 * `afterEach` runs for aborted, cancelled and duplicated navigations too, so a
 * target the user never reached is neither recorded nor counted as a view.
 */
export function trackNavigation(
   to: RouteLocationNormalized,
   _from: RouteLocationNormalized,
   failure?: NavigationFailure | void,
): void {
   if (failure)
      return;

   setCurrentRouteName(to.name);

   const { trackEvent } = useAnalytics();
   trackEvent('page:view', { path: to.fullPath });
}
